import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Box, Text } from '@marvelapp/ui';
import { CopyToClipboard } from '@marvelapp/ui-internal';
export default function PanelLine(_a) {
    var children = _a.children;
    return (React.createElement(Line, null,
        React.createElement(Circle, null),
        React.createElement(Box, { flex: 1, marginLeft: 2 },
            React.createElement(CopyToClipboard, { as: Text, btnText: children, cursor: "pointer", display: "inline-block", fontSize: 2, hoverBoxShadow: "borders.bottom", text: children }))));
}
function Circle() {
    return (React.createElement(Box, { border: "2px solid", borderColor: "smokeDark", borderRadius: 4, height: 8, width: 8 }));
}
var Line = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-left: 4px;\n  margin-bottom: 8px;\n\n  &:last-child {\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding-left: 4px;\n  margin-bottom: 8px;\n\n  &:last-child {\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n"])));
var templateObject_1;
